// extracted by mini-css-extract-plugin
export default {"table":"table_table__kFzuW","cellWrapper":"table_cellWrapper__JKR9w","image":"table_image__rwR2H","productStatus":"table_productStatus__sBUoF"};